module.exports = __webpack_public_path__ + "static/media/gryphon-nest-logo.3f3d401b.svg";